import { render, staticRenderFns } from "./CancelPlan.vue?vue&type=template&id=5d8a5020&"
import script from "./CancelPlan.vue?vue&type=script&lang=js&"
export * from "./CancelPlan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports